var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgB2BOfferDecor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 390,
  height: 285,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE140",
  d: "M210.747.18C58.589 5.109 7.084 104.51.351 153.597c-11.221 167.413 249.67 154.535 340.562 73.908C431.804 146.877 400.946-5.978 210.747.181"
})));
export default SvgB2BOfferDecor;